"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: lifecycle/v2/lifecycle-enum-v2.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flifecycle%2Fv2%2Flifecycle-enum-v2.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressTypeToJSON = exports.progressTypeFromJSON = exports.helperCardPriorityToJSON = exports.helperCardPriorityFromJSON = exports.displayLocationToJSON = exports.displayLocationFromJSON = exports.statusToJSON = exports.statusFromJSON = exports.ProgressType = exports.HelperCardPriority = exports.DisplayLocation = exports.Status = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.lifecycle.v2.proto';
var Status;
(function (Status) {
    Status["INVALID_STATUS"] = "INVALID_STATUS";
    Status["READY"] = "READY";
    Status["PENDING"] = "PENDING";
    Status["COMPLETED"] = "COMPLETED";
    Status["FAILED"] = "FAILED";
    Status["LOCKED"] = "LOCKED";
    Status["SKIPPED"] = "SKIPPED";
    Status["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Status || (exports.Status = Status = {}));
var DisplayLocation;
(function (DisplayLocation) {
    DisplayLocation["INVALID_DISPLAY_LOCATION"] = "INVALID_DISPLAY_LOCATION";
    DisplayLocation["SPENDING_VIEW"] = "SPENDING_VIEW";
    DisplayLocation["FAMILY_VIEW"] = "FAMILY_VIEW";
    DisplayLocation["INVESTING_VIEW"] = "INVESTING_VIEW";
    DisplayLocation["SAVINGS_VIEW"] = "SAVINGS_VIEW";
    DisplayLocation["ACCOUNT_DETAILS_VIEW"] = "ACCOUNT_DETAILS_VIEW";
    DisplayLocation["CARD_MANAGEMENT_VIEW"] = "CARD_MANAGEMENT_VIEW";
    DisplayLocation["REFERRAL_VIEW"] = "REFERRAL_VIEW";
    DisplayLocation["CREDIT_HEALTH"] = "CREDIT_HEALTH";
    DisplayLocation["ACCOUNTS_LIST"] = "ACCOUNTS_LIST";
    DisplayLocation["MOVE_MONEY"] = "MOVE_MONEY";
    DisplayLocation["BORROWING_VIEW"] = "BORROWING_VIEW";
    DisplayLocation["REWARDS_VIEW"] = "REWARDS_VIEW";
    DisplayLocation["CRYPTO_ASSET_VIEW"] = "CRYPTO_ASSET_VIEW";
    DisplayLocation["ACCOUNT_COMPLETION"] = "ACCOUNT_COMPLETION";
    DisplayLocation["PROFILE_VIEW"] = "PROFILE_VIEW";
    DisplayLocation["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DisplayLocation || (exports.DisplayLocation = DisplayLocation = {}));
var HelperCardPriority;
(function (HelperCardPriority) {
    HelperCardPriority["INVALID_PRIORITY"] = "INVALID_PRIORITY";
    HelperCardPriority["LOWEST"] = "LOWEST";
    HelperCardPriority["LOW"] = "LOW";
    HelperCardPriority["MEDIUM"] = "MEDIUM";
    HelperCardPriority["HIGH"] = "HIGH";
    HelperCardPriority["CRITICAL"] = "CRITICAL";
    HelperCardPriority["UNRECOGNIZED"] = "UNRECOGNIZED";
})(HelperCardPriority || (exports.HelperCardPriority = HelperCardPriority = {}));
var ProgressType;
(function (ProgressType) {
    ProgressType["INVALID_PROGRESS_TYPE"] = "INVALID_PROGRESS_TYPE";
    /**
     * ONBOARDING - Used for Account Progress
     */
    ProgressType["ONBOARDING"] = "ONBOARDING";
    /**
     * BASIC - Account Progress basic stage.
     */
    ProgressType["BASIC"] = "BASIC";
    /**
     * NO_INTEREST - Account Progress interest-based stage.
     */
    ProgressType["NO_INTEREST"] = "NO_INTEREST";
    ProgressType["BUILD_CREDIT"] = "BUILD_CREDIT";
    ProgressType["EARN_CASHBACK"] = "EARN_CASHBACK";
    ProgressType["GET_PAID_EARLY"] = "GET_PAID_EARLY";
    ProgressType["GROW_SAVINGS"] = "GROW_SAVINGS";
    ProgressType["INVEST_MONEY"] = "INVEST_MONEY";
    /**
     * BECOME_SPONSOR - Account Progress for sponsors.
     */
    ProgressType["BECOME_SPONSOR"] = "BECOME_SPONSOR";
    ProgressType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProgressType || (exports.ProgressType = ProgressType = {}));
function statusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS':
            return Status.INVALID_STATUS;
        case 1:
        case 'READY':
            return Status.READY;
        case 2:
        case 'PENDING':
            return Status.PENDING;
        case 3:
        case 'COMPLETED':
            return Status.COMPLETED;
        case 4:
        case 'FAILED':
            return Status.FAILED;
        case 5:
        case 'LOCKED':
            return Status.LOCKED;
        case 6:
        case 'SKIPPED':
            return Status.SKIPPED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Status.UNRECOGNIZED;
    }
}
exports.statusFromJSON = statusFromJSON;
function statusToJSON(object) {
    switch (object) {
        case Status.INVALID_STATUS:
            return 'INVALID_STATUS';
        case Status.READY:
            return 'READY';
        case Status.PENDING:
            return 'PENDING';
        case Status.COMPLETED:
            return 'COMPLETED';
        case Status.FAILED:
            return 'FAILED';
        case Status.LOCKED:
            return 'LOCKED';
        case Status.SKIPPED:
            return 'SKIPPED';
        case Status.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.statusToJSON = statusToJSON;
function displayLocationFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DISPLAY_LOCATION':
            return DisplayLocation.INVALID_DISPLAY_LOCATION;
        case 1:
        case 'SPENDING_VIEW':
            return DisplayLocation.SPENDING_VIEW;
        case 2:
        case 'FAMILY_VIEW':
            return DisplayLocation.FAMILY_VIEW;
        case 3:
        case 'INVESTING_VIEW':
            return DisplayLocation.INVESTING_VIEW;
        case 4:
        case 'SAVINGS_VIEW':
            return DisplayLocation.SAVINGS_VIEW;
        case 5:
        case 'ACCOUNT_DETAILS_VIEW':
            return DisplayLocation.ACCOUNT_DETAILS_VIEW;
        case 6:
        case 'CARD_MANAGEMENT_VIEW':
            return DisplayLocation.CARD_MANAGEMENT_VIEW;
        case 7:
        case 'REFERRAL_VIEW':
            return DisplayLocation.REFERRAL_VIEW;
        case 8:
        case 'CREDIT_HEALTH':
            return DisplayLocation.CREDIT_HEALTH;
        case 9:
        case 'ACCOUNTS_LIST':
            return DisplayLocation.ACCOUNTS_LIST;
        case 10:
        case 'MOVE_MONEY':
            return DisplayLocation.MOVE_MONEY;
        case 11:
        case 'BORROWING_VIEW':
            return DisplayLocation.BORROWING_VIEW;
        case 12:
        case 'REWARDS_VIEW':
            return DisplayLocation.REWARDS_VIEW;
        case 13:
        case 'CRYPTO_ASSET_VIEW':
            return DisplayLocation.CRYPTO_ASSET_VIEW;
        case 14:
        case 'ACCOUNT_COMPLETION':
            return DisplayLocation.ACCOUNT_COMPLETION;
        case 15:
        case 'PROFILE_VIEW':
            return DisplayLocation.PROFILE_VIEW;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DisplayLocation.UNRECOGNIZED;
    }
}
exports.displayLocationFromJSON = displayLocationFromJSON;
function displayLocationToJSON(object) {
    switch (object) {
        case DisplayLocation.INVALID_DISPLAY_LOCATION:
            return 'INVALID_DISPLAY_LOCATION';
        case DisplayLocation.SPENDING_VIEW:
            return 'SPENDING_VIEW';
        case DisplayLocation.FAMILY_VIEW:
            return 'FAMILY_VIEW';
        case DisplayLocation.INVESTING_VIEW:
            return 'INVESTING_VIEW';
        case DisplayLocation.SAVINGS_VIEW:
            return 'SAVINGS_VIEW';
        case DisplayLocation.ACCOUNT_DETAILS_VIEW:
            return 'ACCOUNT_DETAILS_VIEW';
        case DisplayLocation.CARD_MANAGEMENT_VIEW:
            return 'CARD_MANAGEMENT_VIEW';
        case DisplayLocation.REFERRAL_VIEW:
            return 'REFERRAL_VIEW';
        case DisplayLocation.CREDIT_HEALTH:
            return 'CREDIT_HEALTH';
        case DisplayLocation.ACCOUNTS_LIST:
            return 'ACCOUNTS_LIST';
        case DisplayLocation.MOVE_MONEY:
            return 'MOVE_MONEY';
        case DisplayLocation.BORROWING_VIEW:
            return 'BORROWING_VIEW';
        case DisplayLocation.REWARDS_VIEW:
            return 'REWARDS_VIEW';
        case DisplayLocation.CRYPTO_ASSET_VIEW:
            return 'CRYPTO_ASSET_VIEW';
        case DisplayLocation.ACCOUNT_COMPLETION:
            return 'ACCOUNT_COMPLETION';
        case DisplayLocation.PROFILE_VIEW:
            return 'PROFILE_VIEW';
        case DisplayLocation.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.displayLocationToJSON = displayLocationToJSON;
function helperCardPriorityFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PRIORITY':
            return HelperCardPriority.INVALID_PRIORITY;
        case 1:
        case 'LOWEST':
            return HelperCardPriority.LOWEST;
        case 2:
        case 'LOW':
            return HelperCardPriority.LOW;
        case 3:
        case 'MEDIUM':
            return HelperCardPriority.MEDIUM;
        case 4:
        case 'HIGH':
            return HelperCardPriority.HIGH;
        case 5:
        case 'CRITICAL':
            return HelperCardPriority.CRITICAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return HelperCardPriority.UNRECOGNIZED;
    }
}
exports.helperCardPriorityFromJSON = helperCardPriorityFromJSON;
function helperCardPriorityToJSON(object) {
    switch (object) {
        case HelperCardPriority.INVALID_PRIORITY:
            return 'INVALID_PRIORITY';
        case HelperCardPriority.LOWEST:
            return 'LOWEST';
        case HelperCardPriority.LOW:
            return 'LOW';
        case HelperCardPriority.MEDIUM:
            return 'MEDIUM';
        case HelperCardPriority.HIGH:
            return 'HIGH';
        case HelperCardPriority.CRITICAL:
            return 'CRITICAL';
        case HelperCardPriority.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.helperCardPriorityToJSON = helperCardPriorityToJSON;
function progressTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PROGRESS_TYPE':
            return ProgressType.INVALID_PROGRESS_TYPE;
        case 1:
        case 'ONBOARDING':
            return ProgressType.ONBOARDING;
        case 2:
        case 'BASIC':
            return ProgressType.BASIC;
        case 3:
        case 'NO_INTEREST':
            return ProgressType.NO_INTEREST;
        case 4:
        case 'BUILD_CREDIT':
            return ProgressType.BUILD_CREDIT;
        case 5:
        case 'EARN_CASHBACK':
            return ProgressType.EARN_CASHBACK;
        case 6:
        case 'GET_PAID_EARLY':
            return ProgressType.GET_PAID_EARLY;
        case 7:
        case 'GROW_SAVINGS':
            return ProgressType.GROW_SAVINGS;
        case 8:
        case 'INVEST_MONEY':
            return ProgressType.INVEST_MONEY;
        case 9:
        case 'BECOME_SPONSOR':
            return ProgressType.BECOME_SPONSOR;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ProgressType.UNRECOGNIZED;
    }
}
exports.progressTypeFromJSON = progressTypeFromJSON;
function progressTypeToJSON(object) {
    switch (object) {
        case ProgressType.INVALID_PROGRESS_TYPE:
            return 'INVALID_PROGRESS_TYPE';
        case ProgressType.ONBOARDING:
            return 'ONBOARDING';
        case ProgressType.BASIC:
            return 'BASIC';
        case ProgressType.NO_INTEREST:
            return 'NO_INTEREST';
        case ProgressType.BUILD_CREDIT:
            return 'BUILD_CREDIT';
        case ProgressType.EARN_CASHBACK:
            return 'EARN_CASHBACK';
        case ProgressType.GET_PAID_EARLY:
            return 'GET_PAID_EARLY';
        case ProgressType.GROW_SAVINGS:
            return 'GROW_SAVINGS';
        case ProgressType.INVEST_MONEY:
            return 'INVEST_MONEY';
        case ProgressType.BECOME_SPONSOR:
            return 'BECOME_SPONSOR';
        case ProgressType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.progressTypeToJSON = progressTypeToJSON;
//# sourceMappingURL=lifecycle-enum-v2.js.map